<div class="container">
  <header class="header">
      <img src="../../../assets/images/Logo-256px.svg" alt="">
      <h2>PDF Magnet</h2>
  </header>
</div>